import _ from 'lodash';
import React from 'react';
import styled from 'styled-components';
import humanFormat from 'human-format';
import propTypes from '../../common/prop-types';
import FundSizeInfo from './fund-size-info';
import InceptionDateInfo from './inception-date-info';
import InvestmentHorizonInfo from './investment-horizon-info';
import MoreInfo from './more-info';

const round = { decimals: 0, separator: '' };
const upper = key => fnd => _.toUpper(_.get(fnd, key));

const buildProps = {
  apirCode: { type: 'apir', value: upper('apirCode') },
  currency: { value: upper('currency') },
  fundSize: { Component: FundSizeInfo },
  inceptionDate: { Component: InceptionDateInfo },
  investmentHorizon: { Component: InvestmentHorizonInfo },
  minimumInvestment: {
    value: fnd => _.toUpper(`$${humanFormat(_.get(fnd, 'minimumInvestment'), round)}`),
  },
  name: { type: 'fund name' },
  moreInfo: { type: 'more information', Component: MoreInfo },
  stockCode: { type: 'stock code', value: upper('stockCode') },
};

const getType = key => _.lowerCase(_.get(buildProps, `${key}.type`, key));

const Container = styled.div`
  display: flex;
  flex-direction: column;
  font: ${props => props.theme.fontWeightNormal} 19px/120% ${props => props.theme.fontFamilyBody};
  color: ${props => props.theme.bodyColor};

  & > span {
    font-weight: ${props => props.theme.fontWeightBold};
    color: ${props => props.theme.secondaryColor};
    font-size: 14px;
    text-transform: uppercase;
    margin-bottom: 4px;
    height: 22px !important;
  }

  & > section {
    text-transform: capitalize;
    > small {
      text-transform: none;
      margin-left: 10px;
      font-size: 14px;
    }
  }
`;

export default function withKeyInfo(key) {
  const valueFunc = _.get(buildProps, `${key}.value`);
  const ValueComponent = _.get(buildProps, `${key}.Component`);

  function Component({ fund }) {
    let value;

    if (key === 'moreInfo') {
      const pdsFileUrl = _.get(fund, 'pdsFileUrl');
      const tmdFileUrl = _.get(fund, 'tmdFileUrl');

      if (!pdsFileUrl && !tmdFileUrl) {
        return null;
      }
    } else {
      value = _.get(fund, key);

      if (!value) {
        return null;
      }
    }

    let label = getType(key);
    label = label.startsWith('fund ') ? label.replace('fund ', '') : label;

    return (
      <Container>
        <span>{label}</span>
        <section>
          {!!valueFunc && valueFunc(fund)}
          {!!ValueComponent && <ValueComponent fund={fund} />}
          {(!valueFunc && !ValueComponent) && value}
        </section>
      </Container>
    );
  }

  /* eslint-disable-next-line react/require-default-props */
  Component.propTypes = { fund: propTypes.fund };

  Component.displayName = _.capitalize(key);

  return Component;
}
